// We don't need to typecheck or lint this file as this code is provided by Google themselves.
const googleTagManagerTrackingID = 'GTM-K3BK4J7';

/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
const googleAnalytics = () => {
  const gtmJS = document.createElement('script');

  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  gtmJS.async = true;
  gtmJS.src = `https://www.googletagmanager.com/gtm.js?id=${googleTagManagerTrackingID}&l=dataLayer`;
  document.head.appendChild(gtmJS);
};

export default googleAnalytics;
